export default __webpack_public_path__ + "static/media/play-circle.428b7491.svg";